import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function TelephoneCellphoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const validTelephoneCellphone =
      /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/.test(value);

    return !validTelephoneCellphone
      ? {
          telephoneCellphone: {
            valid: false,
          },
        }
      : null;
  };
}
